import { API_TYPES } from "@src/appV2/api";
import { z } from "zod";

export const workerFavoritePlacementDataSchema = z.object({
  type: z.literal(API_TYPES.workerFavoritePlacement),
  id: z.string(),
  attributes: z.object({
    createdAt: z.string(),
  }),
  relationships: z.object({
    worker: z.object({
      data: z.object({
        type: z.literal(API_TYPES.worker),
        id: z.string(),
      }),
    }),
    workplace: z.object({
      data: z.object({
        type: z.literal(API_TYPES.workplace),
        id: z.string(),
      }),
    }),
    placement: z.object({
      data: z.object({
        type: z.literal(API_TYPES.placement),
        id: z.string(),
      }),
    }),
  }),
});
